// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___kgQZ1 {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
}
.styles__container___kgQZ1 section {
  margin-bottom: 45px;
}
.styles__container___kgQZ1 {
  max-width: 1140px !important;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 3px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 1em;
}
.styles__container___kgQZ1 section {
  margin-bottom: 45px;
}
.styles__number___ClPLL {
  text-align: right;
}
.styles__striped___I24Rl tr.styles__row___b3dRm {
  background-color: #efefef;
}
.styles__striped___I24Rl tr.styles__items___ATVBe td {
  border-top: none !important;
  padding-top: 0 !important;
}
.styles__ellipsis___nhnwA {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.styles__searchContainer___n9IoK {
  position: relative;
  margin: 1em 0;
  display: flex;
  align-items: center;
}
.styles__searchContainer___n9IoK .checkbox-input {
  margin-bottom: 0px;
  margin-left: 1.5em;
}
.styles__searchInput___v646W {
  width: 239px !important;
  padding-right: 26px !important;
}
.styles__searchHelp___Dabx_ {
  margin-left: -26px;
  cursor: pointer;
  padding-right: 8px !important;
}
.styles__deliveredHelp___oSYIJ {
  cursor: pointer;
  padding-left: 4px;
}
.styles__infoIcon___aQ68b {
  margin-left: 3px;
  margin-top: 1px;
}
.styles__warning___WOzFL {
  padding: 0 1em 2em 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.styles__center___bGczS {
  display: flex;
  justify-content: center;
  align-items: center;
}
.styles__center___bGczS .checkbox-input {
  margin-bottom: 0px;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/shared/layout.less","webpack://./src/components/components/OrdersList/styles.less"],"names":[],"mappings":"AAEA;EACE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ACDF;ADTA;EAYI,mBAAA;ACAJ;AAZA;EDCE,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kDAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ECRA,mBAAA;AAuBF;AAzBA;EDYI,mBAAA;ACgBJ;AAvBA;EACC,iBAAA;AAyBD;AAtBA;EAEI,yBAAA;AAuBJ;AAzBA;EAMI,2BAAA;EACA,yBAAA;AAsBJ;AAlBA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAoBF;AAjBA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAmBF;AAvBA;EAOI,kBAAA;EACA,kBAAA;AAmBJ;AAfA;EACE,uBAAA;EACA,8BAAA;AAiBF;AAdA;EACE,kBAAA;EACA,eAAA;EACA,6BAAA;AAgBF;AAbA;EACE,eAAA;EACA,iBAAA;AAeF;AAZA;EACE,gBAAA;EACA,eAAA;AAcF;AAXA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAaF;AAVA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAYF;AAfA;EAMI,kBAAA;EACA,gBAAA;AAYJ","sourcesContent":["@import './variables.less';\n\n.container {\n  max-width: 1140px !important;\n  margin-top: 20px;\n  margin-bottom: 15px;\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: @eon-box-shadow;\n  transition: @eon-transition-default;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  section {\n    margin-bottom: 45px;\n  }\n}\n","@import '../../../shared/layout.less';\n\n.container {\n  .container();\n  padding-bottom: 1em;\n}\n\n.number {\n\ttext-align: right;\n}\n\n.striped {\n  tr.row {\n    background-color: #efefef;\n  }\n\n  tr.items td {\n    border-top: none !important;\n    padding-top: 0 !important;\n  }\n}\n\n.ellipsis {\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.searchContainer {\n  position: relative;\n  margin: 1em 0;\n  display: flex;\n  align-items: center;\n\n  :global(.checkbox-input) {\n    margin-bottom: 0px;\n    margin-left: 1.5em;\n  }\n}\n\n.searchInput {\n  width: 239px !important;\n  padding-right: 26px !important;\n}\n\n.searchHelp {\n  margin-left: -26px;\n  cursor: pointer;\n  padding-right: 8px !important;\n}\n\n.deliveredHelp {\n  cursor: pointer;\n  padding-left: 4px;\n}\n\n.infoIcon {\n  margin-left: 3px;\n  margin-top: 1px;\n}\n\n.warning {\n  padding: 0 1em 2em 1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  :global(.checkbox-input) {\n    margin-bottom: 0px;\n    margin-left: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___kgQZ1`,
	"number": `styles__number___ClPLL`,
	"striped": `styles__striped___I24Rl`,
	"row": `styles__row___b3dRm`,
	"items": `styles__items___ATVBe`,
	"ellipsis": `styles__ellipsis___nhnwA`,
	"searchContainer": `styles__searchContainer___n9IoK`,
	"searchInput": `styles__searchInput___v646W`,
	"searchHelp": `styles__searchHelp___Dabx_`,
	"deliveredHelp": `styles__deliveredHelp___oSYIJ`,
	"infoIcon": `styles__infoIcon___aQ68b`,
	"warning": `styles__warning___WOzFL`,
	"center": `styles__center___bGczS`
};
export default ___CSS_LOADER_EXPORT___;
